import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

function AboutUs() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="about-container">
     
      <header className="home-nav-header">
        <nav className="home-nav-container">
          <div className="home-logo">MHMV</div>
          
       
          <div 
            className={`home-nav-toggle ${isMenuOpen ? 'active' : ''}`} 
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          
          <ul className={`home-nav-list ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" className="home-nav-link" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            
            <li className="home-dropdown">
              <span className="home-nav-link home-dropdown-toggle">Services</span>
              <ul className="home-dropdown-menu">
                <li><Link to="/mv-agri" className="home-dropdown-item" onClick={() => setIsMenuOpen(false)}>MV Agri</Link></li>
                <li><Link to="/mv-profile" className="home-dropdown-item" onClick={() => setIsMenuOpen(false)}>MV Profile</Link></li>
              </ul>
            </li>
          </ul>
        </nav>
      </header>

      
      <section className="about-hero-section">
        <div className="about-hero-background">
          <img 
            src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
            alt="Vero Disruptors Innovation" 
          />
        </div>
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1>Welcome to Vero Disruptors</h1>
          <p>Driving innovation into everyday life through AI, data science, and sustainable technology</p>
        </div>
      </section>

      
      <section className="company-story">
        <div className="container">
          <div className="story-grid">
            <div className="story-content">
              <h2>Our Story</h2>
              <p className="story-intro">
                <strong>Vero Disruptors Pvt Ltd</strong> is a dynamic startup founded in <strong>April 2022</strong> and headquartered in <strong>Ongole, Andhra Pradesh</strong>. We're on a mission to bridge the gap between cutting-edge technology and real-world applications.
              </p>
              
              <div className="story-stats">
                <div className="stat-card">
                  <div className="stat-image">
                    <img src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Innovation" />
                  </div>
                  <div className="stat-content">
                    <h4>Innovation Driven</h4>
                    <p>Pioneering practical technology solutions</p>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-image">
                    <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Growth" />
                  </div>
                  <div className="stat-content">
                    <h4>Rapid Growth</h4>
                    <p>Expanding our impact since 2022</p>
                  </div>
                </div>
                <div className="stat-card">
                  <div className="stat-image">
                    <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Sustainability" />
                  </div>
                  <div className="stat-content">
                    <h4>Sustainability Focus</h4>
                    <p>Eco-responsible technology solutions</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="story-visual">
              <div className="main-story-image">
                <img 
                  src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="Vero Disruptors Team Collaboration" 
                />
              </div>
            </div>
          </div>
        </div>
      </section>


<section className="mission-section">
  <div className="container">
    <div className="mission-content">
      <div className="mission-image">
        <img src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80" alt="Our Mission" />
      </div>
      <div className="mission-text">
        <div className="mission-centered-heading">
          <h2>Our Mission</h2>
          <div className="mission-divider"></div>
        </div>
        <p>
          At Vero Disruptors, we are on a mission to drive innovation into everyday life. We believe data science and AI hold transformative power — and we're committed to turning that into practical, scalable solutions for people and society.
        </p>
      </div>
    </div>
  </div>
</section>

 
      <section className="services-section">
        <div className="container">
          <h2>What We Do</h2>
          <p className="section-subtitle">Comprehensive solutions for the digital age</p>
          
          <div className="services-grid">
            <div className="service-card">
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="Product Development" 
                />
              </div>
              <div className="service-content">
                <h3>Product Development</h3>
                <p>We build reusable, data-driven solutions tailored to streamline complex processes. From strategic planning to live demos, deployment, and maintenance — we partner with clients at every step of the product lifecycle.</p>
              </div>
            </div>

            <div className="service-card">
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1521791055366-0d553872125f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="Technical Talent & Recruitment" 
                />
              </div>
              <div className="service-content">
                <h3>Technical Talent & Recruitment</h3>
                <p>Supporting your projects with world-class data, ML, and AI talent. We also assist in sourcing and upskilling technical professionals to meet organizational needs.</p>
              </div>
            </div>

            <div className="service-card">
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="IT Training & Internships" 
                />
              </div>
              <div className="service-content">
                <h3>IT Training & Internships</h3>
                <p>We provide hands-on tech training and internships to nurture fresh graduates and ignite new talent — fuelling both our mission and our mission partners' growth.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      
      <section className="sustainability-section">
        <div className="container">
          <div className="sustainability-grid">
            <div className="sustainability-content">
              <h2>Our Promise to Nature</h2>
              <p>
                We're passionate about the planet. Vero Disruptors is committed to eco-responsible innovations that align with sustainable development — and we actively welcome collaborations with organizations striving to preserve our natural resources.
              </p>
              <div className="sustainability-features">
                <div className="sustainability-item">
                  <div className="feature-image">
                    <img src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Eco Innovation" />
                  </div>
                  <span>Eco-responsible Innovation</span>
                </div>
                <div className="sustainability-item">
                  <div className="feature-image">
                    <img src="https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="Sustainable Development" />
                  </div>
                  <span>Sustainable Development</span>
                </div>
                <div className="sustainability-item">
                  <div className="feature-image">
                    <img src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Collaboration" />
                  </div>
                  <span>Environmental Collaboration</span>
                </div>
              </div>
            </div>
            <div className="sustainability-visual">
              <img 
                src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                alt="Sustainable Technology" 
              />
            </div>
          </div>
        </div>
      </section>

      
      <section className="agritech-showcase">
        <div className="container">
          <div className="agritech-grid">
            <div className="agritech-content">
              <div className="project-badge">Innovation Project</div>
              <h2>MHMV AgriTech Platform</h2>
              <p className="project-description">
                Our Android application designed specifically to support and empower farmers, bringing smart and accessible technology to the agriculture sector where it's truly needed.
              </p>
              
              <div className="project-status">
                <div className="status-indicator">
                  <div className="status-dot"></div>
                  <span>Currently in Testing Phase - Google Play Console</span>
                </div>
              </div>

              <div className="project-highlights">
                <h4>What We're Building</h4>
                <div className="highlights-list">
                  <div className="highlight-item">
                    <div className="highlight-image">
                      <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Farmer Empowerment" />
                    </div>
                    <div>
                      <h5>Farmer Empowerment</h5>
                      <p>Technology solutions designed specifically for farmer needs</p>
                    </div>
                  </div>
                  <div className="highlight-item">
                    <div className="highlight-image">
                      <img src="https://images.unsplash.com/photo-1556656793-08538906a9f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Smart Agriculture" />
                    </div>
                    <div>
                      <h5>Smart Agriculture</h5>
                      <p>Bringing accessible tech to transform traditional farming</p>
                    </div>
                  </div>
                  <div className="highlight-item">
                    <div className="highlight-image">
                      <img src="https://images.unsplash.com/photo-1416879595882-3373a0480b5b?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80" alt="Impact Driven" />
                    </div>
                    <div>
                      <h5>Impact-Driven</h5>
                      <p>Solutions that create real difference in farmers' lives</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="project-note">
                <p><strong>Stay Tuned:</strong> We're learning, iterating fast, and focused on creating impact-driven solutions. Launch isn't far off!</p>
              </div>
            </div>
            <div className="agritech-preview">
              <div className="app-mockup">
                <img 
                  src="https://images.unsplash.com/photo-1556656793-08538906a9f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="MHMV AgriTech App - Farmer Empowerment" 
                />
                <div className="mockup-overlay">
                  
                  <div className="play-store-badge">Comming Soon</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Join Us on the Journey</h2>
            <p>
              Whether you're seeking cutting-edge AI and data products, looking to collaborate on eco-conscious tech, or want to grow through our training programs — Vero Disruptors is here to make it happen.
            </p>
            <p className="cta-highlight">
              Welcome to the future of smarter, sustainable solutions. Welcome to Vero Disruptors.
            </p>
            <div className="cta-actions">
              <Link to="/mv-profile" className="cta-btn primary">Get Started</Link>
              <Link to="/mv-agri" className="cta-btn secondary">Explore MHMV Agri</Link>
              <a href="mailto:Venkatmor@verodisruptors.com" className="cta-btn outline">Contact Us</a>
            </div>
          </div>
        </div>
      </section>

      
      <footer className="home-footer">
        <div className="container">
          <div className="home-footer-grid">
            <div className="footer-section">
              <h3>Vero Disruptors</h3>
              <p>Driving innovation for a sustainable future through AI, data analytics, and talent development.</p>
            </div>
            
            

            
            <div className="footer-section">
              <h3>Contact</h3>
              <p>Email: Venkatmor@verodisruptors.com</p>
              <p>Phone: +91 9032584791</p>
              <p>Location: Ongole, Andhra Pradesh</p>
            </div>
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/" className="home-footer-link">Home</Link></li>
                <li><Link to="/mv-profile" className="home-footer-link">MV Profile</Link></li>
                <li><Link to="/mv-agri" className="home-footer-link">MV Agri</Link></li>
              </ul>
            </div>
          </div>
          <div className="home-footer-bottom">
            <p>&copy; 2025 Vero Disruptors Pvt Ltd. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AboutUs;